import mixpanel from 'mixpanel-browser';

const getToken = () => (
  (typeof window !== 'undefined' && window.APP_CONFIG && window.APP_CONFIG.MIXPANEL_TOKEN)
  || process.env.VUE_APP_MIXPANEL_TOKEN
  || ''
);

/**
 * Mixpanel wrapper. Token yoksa (local dev vb.) tüm çağrılar sessizce no-op olur,
 * böylece analytics kurulu olmadan da uygulama sorunsuz çalışır.
 */
class AnalyticsService {
  constructor() {
    this.enabled = false;
  }

  init() {
    const token = getToken();
    if (!token) {
      this.enabled = false;
      return;
    }

    mixpanel.init(token, {
      track_pageview: true,
      persistence: 'localStorage',
    });
    this.enabled = true;
  }

  identify(user) {
    if (!this.enabled || !user) return;

    mixpanel.identify(String(user.id));
    mixpanel.people.set({
      $email: user.email,
      $name: user.name,
      roles: user.roles,
    });
  }

  reset() {
    if (!this.enabled) return;
    mixpanel.reset();
  }

  track(eventName, properties = {}) {
    if (!this.enabled) return;
    mixpanel.track(eventName, properties);
  }
}

export default new AnalyticsService();
